<template>
  <div class="images-section">
    <div class="carousel-wrapper">
      <sg-vue-slick-carousel
        ref='jewelCarousel'
        v-if="areImagesReady"
      >
        <img
          v-for="(image, index) in jewel.images"
          v-bind:key="image.image"
          class="jewel-carousel-image"
          v-bind:alt="metaDescription"
          v-bind:src="image.image"
          v-bind:title="jewel.title"
          v-on:load="updateCarousel($event, index)"
          itemprop="image"
        >
      </sg-vue-slick-carousel>
    </div>
    <meta
      v-if="!jewel.description"
      itemprop="description"
      v-bind:content="metaDescription"
    >
  </div>
</template>

<script>
import SgVueSlickCarousel from '../utils/SgVueSlickCarousel'

export default {
  name: 'CatalogJewelArticleImageCarousel',
  props: ['jewel'],
  components: {SgVueSlickCarousel},
  data: function () {
    return {}
  },
  computed: {
    metaDescription: function () {
      const title = this.jewel.title
      const price = this.jewel.price
      const code = this.jewel.vendor_code ? this.jewel.vendor_code : this.jewel.note
      return (price > 0)
        ? `${title} ${code} от ювелирной фирмы "Стиль" по цене ${price} руб.`
        : `${title} ${code} от ювелирной фирмы "Стиль"`
    },
    areImagesReady: function () {
      return (this.jewel.images && this.jewel.images.length > 0)
    }
  },
  methods: {
    updateCarousel: function (event, index) {
      if (index === 0) {
        this.$refs.jewelCarousel.$el.querySelector('.slick-list').style.height =
          `${event.target.height}px`
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .images-section {
    @include vertical-breakpoint-padding("mobile", 3em, 2em);
    align-items: center;

    @include media (">tablet") {
      flex-basis: 50%;
      max-width: 50%;
    };

    & > .carousel-wrapper {
      @include centered-block-width(
        $desktop: 80%, $big-tablet: 80%, $small-tablet: 80%, $mobile: 90%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-jewel-article/CatalogJewelArticleImageCarousel.vue